<template>
  <a-modal
    :title="title"
    :width="600"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    :cancelText="$t('close')"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">

        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          :label="$t('sort')">
          <a-input :placeholder="$t('sortPlaceholder')" v-decorator="[ 'sort', validatorRules.sort]"/>
        </a-form-item>



        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          :label="$t('type')">
          <dict-radio-group
              v-decorator="['type', validatorRules.type]"
              :dict-code="DICT_CODE.PRODICT_CONFIG_TYPE"
          />
        </a-form-item>

         <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          :label="$t('configName')">
          <a-input :placeholder="$t('inputConfigName')" v-decorator="[ 'name', validatorRules.name]"/>
        </a-form-item>

        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          :label="$t('configContent')">
          <a-input :placeholder="$t('inputConfigContent')" v-decorator="[ 'value', validatorRules.value]"/>
        </a-form-item>


      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>
import pick from 'lodash/pick'
import {addProductConfig,editProductConfig } from '@/webpublicapi/operation'
import DictRadioGroup from '../../modules/DictRadioGroup';
// duplicateCheck
export default {
  name: 'DictModal',
  components:{
    DictRadioGroup
  },
  data () {
    return {
      value: 1,
      title: this.$t('action'),
      productId:'',
      visibleCheck: true,
      visible: false,
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      confirmLoading: false,
      form: this.$form.createForm(this),

    }
  },
  computed: {
    validatorRules() {
      return {
        sort: { rules: [{ required: true, message: this.$t('inputSort') }] },
        type: { rules: [{ required: true, message: this.$t('inputType') }] },
        name: { rules: [{ required: true, message: this.$t('inputConfigName') }] },
        value: { rules: [{ required: true, message: this.$t('inputConfigContent') }] },
      }
    }
  },
  created () {
  },
  methods: {
    add (proId,ssId) {
      this.productId = proId
      this.appSsid=ssId
      this.edit({})
    },
    edit (record) {
      this.form.resetFields()
      this.model = Object.assign({}, record)
      this.visible = true;
      const data = pick(this.model, 'sort', 'type', 'name','value');
      this.$nextTick(() => {
        this.form.setFieldsValue(data);
      })
    },
    onChose (checked) {
      if (checked) {

        this.visibleCheck = true
      } else {

        this.visibleCheck = false
      }
    },
    // Confirm
    handleOk () {
      const that = this
      // Trigger form validation
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true
          const formData = Object.assign(this.model, values)
          let obj
          if (!that.model.id) {
            formData.productId = this.productId
            formData.appSsid=this.appSsid
            obj = addProductConfig(formData)
          } else {
             obj = editProductItem(formData)
          }
          obj.then((res) => {
            if (res.code === 1000) {
              that.$message.success(res.msg)
              that.$emit('ok')
            } else {
              that.$message.warning(res.msg)
            }
          }).finally(() => {
            that.confirmLoading = false
            that.close()
          })
        }
      })
    },
    // Close
    handleCancel () {
      this.close()
    },
    close () {
      this.$emit('close')
      this.visible = false
    }
  }
}
</script>
